<script>
import MainButton from "@/components/helpers/MainButton.vue";
import TooltipUpBalance from "@/components/tooltips/TooltipUpBalance.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { COUNTRIES } from "@/modules/international-operations/constants";

export default {
  components: { TooltipUpBalance, MainButton },

  props: {
    isGray: {
      type: Boolean,
      default: false,
    },

    isInternational: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isShowRefillTooltip: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      currentCountry: (state) => state.internationalOperations.currentCountry,
    }),

    ...mapGetters({
      getUserDistributorAccount: "auth/getUserDistributorAccount",
    }),

    COUNTRIES() {
      return COUNTRIES;
    },

    currentCurrency() {
      if (this.currentCountry !== "RUS") {
        return this.COUNTRIES.find(
          (country) => country.slug === this.currentCountry
        )?.currency;
      } else {
        return "";
      }
    },

    currentAccount() {
      if (this.currentCountry !== "RUS") {
        return this.user.accounts.find((account) => {
          return (
            account.user_type === "distributor" &&
            account.account_type === "rc" &&
            account.currency === this.currentCurrency
          );
        });
      } else {
        return this.getUserDistributorAccount;
      }
    },

    formattedSummaryActive() {
      return `${this.currentAccount?.summary_active?.toLocaleString(
        "ru-RU"
      )} RC ${this.currentCurrency}`;
    },

    formattedSummaryHold() {
      return `${this.currentAccount?.summary_hold?.toLocaleString(
        "ru-RU"
      )} RC ${this.currentCurrency}`;
    },
  },

  methods: {
    ...mapActions({
      getInfoWarningSberbankRefill: "warnings/getInfoWarningSberbankRefill",
    }),
  },

  mounted() {
    this.getInfoWarningSberbankRefill();
  },
};
</script>

<template>
  <div class="balance-block" :class="{ 'balance-block_gray': isGray }">
    <h4 class="balance-block__title">Баланс</h4>

    <h2 class="balance-block__current-balance">{{ formattedSummaryActive }}</h2>

    <p class="balance-block__pending-balance">
      В ожидании: {{ formattedSummaryHold }}
    </p>

    <div class="balance-block__wrapper">
      <div class="balance-block__wrapper_test">
        <MainButton
          v-if="!readonly"
          class="balance-block__button"
          :title="'Пополнить'"
          :color="'business-light-violet'"
          @click="isShowRefillTooltip = true"
        />
      </div>

      <TooltipUpBalance
        v-if="isShowRefillTooltip"
        title="Пополнение баланса"
        description="Пополните баланс через банковскую карту"
        :tooltip-position="'bottom'"
        @close="isShowRefillTooltip = false"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.balance-block {
  background-color: $light-primary;
  border-radius: 8px;
  padding: 24px;
  max-width: 337px;
  background-image: url("../../assets/images/balance_block_background.png");
  background-position: right bottom;
  background-size: 204px auto;
  background-repeat: no-repeat;
  width: 100%;

  &_gray {
    background-color: var(--background-light-second, #f8f8f8) !important;
  }

  &__title {
    @include body-1;
    color: $dark-primary;
    margin-bottom: 24px;
  }

  &__current-balance {
    @include title-3;
    color: $dark-primary;
    margin-bottom: 4px;
  }

  &__pending-balance {
    @include text-2;
    color: $dark-fifth;
    margin-bottom: 24px;
  }

  &__wrapper {
    position: relative;
  }

  &__wrapper_test {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__button {
    max-width: 160px;
  }
}

@media (max-width: 1024px) {
  .balance-block {
    max-width: none;
  }
}

@media (max-width: 900px) {
  .balance-block {
    &__title {
      margin-bottom: 16px;
    }

    &__pending-balance {
      margin-bottom: 16px;
    }
  }
}

@media (max-width: 690px) {
  .balance-block {
    background-size: 180px auto;
  }
}
</style>
